export default __webpack_public_path__ + "static/media/about_ukri_logo.25c2e617.png";